import { render, staticRenderFns } from "./CardWChart.vue?vue&type=template&id=8179745e&"
import script from "./CardWChart.vue?vue&type=script&lang=js&"
export * from "./CardWChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports